module.exports = __webpack_public_path__ + "img/sleeve_flounce_width.87c1a5d6.png";